export interface DeviceMetadata {
  screen_width?: number;
  screen_height?: number;
  timezone?: string;
  language?: string;
  color_depth?: number;
  pixel_ratio?: number;
}

export const getDeviceMetadata = (): DeviceMetadata => {
  if (typeof window === "undefined") {
    return {};
  }

  const metadata: DeviceMetadata = {};

  if (screen?.width && screen?.height) {
    metadata.screen_width = screen.width;
    metadata.screen_height = screen.height;
  }

  if (Intl?.DateTimeFormat) {
    try {
      metadata.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch {
      // Timezone detection failed
    }
  }

  if (navigator?.language) {
    metadata.language = navigator.language;
  }

  if (screen?.colorDepth) {
    metadata.color_depth = screen.colorDepth;
  }

  if (window?.devicePixelRatio) {
    metadata.pixel_ratio = window.devicePixelRatio;
  }

  return metadata;
};

export function getDeviceHeaders(): Record<string, string> {
  const meta = getDeviceMetadata();
  const headers: Record<string, string> = {};
  if (meta.screen_width) headers["x-device-screen-width"] = String(meta.screen_width);
  if (meta.screen_height) headers["x-device-screen-height"] = String(meta.screen_height);
  if (meta.timezone) headers["x-device-timezone"] = meta.timezone;
  if (meta.language) headers["x-device-language"] = meta.language;
  if (meta.color_depth) headers["x-device-color-depth"] = String(meta.color_depth);
  if (meta.pixel_ratio) headers["x-device-pixel-ratio"] = String(meta.pixel_ratio);
  return headers;
}

/** Auth/session endpoints where the backend records IP and device context in security logs. */
export const AUTH_DEVICE_HEADER_PATH_SUFFIXES = [
  "/auth/login",
  "/auth/logout",
  "/auth/mfa/complete-login",
  "/auth/mfa/complete-setup",
  "/auth/passkey/authenticate/begin",
  "/auth/passkey/authenticate/complete",
  "/auth/passkey/register/begin",
  "/auth/passkey/register/complete",
  "/users/register",
  "/oidc/login",
  "/auth/oauth/google/callback",
  "/auth/oauth/linkedin/callback",
] as const;

export function shouldAttachDeviceHeadersForPath(pathname: string | null): boolean {
  if (!pathname) {
    return false;
  }
  return AUTH_DEVICE_HEADER_PATH_SUFFIXES.some(
    (suffix) => pathname === suffix || pathname.endsWith(suffix)
  );
}
